import { render, staticRenderFns } from "./Instructions.vue?vue&type=template&id=7b861350&scoped=true"
import script from "./Instructions.js?vue&type=script&lang=js&external"
export * from "./Instructions.js?vue&type=script&lang=js&external"
import style0 from "./Instructions.scss?vue&type=style&index=0&id=7b861350&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b861350",
  null
  
)

export default component.exports